/** Cross-tab auth sync (FE-01 §8, FE-05 FR-FE05-10): `BroadcastChannel('sos-auth')`. */
export type AuthMessage = { type: "login" } | { type: "logout" };

const CHANNEL = "sos-auth";

function open(): BroadcastChannel | null {
  return typeof BroadcastChannel === "function" ? new BroadcastChannel(CHANNEL) : null;
}

export function broadcastAuth(message: AuthMessage): void {
  const channel = open();
  if (!channel) return;
  channel.postMessage(message);
  channel.close();
}

export function subscribeAuth(listener: (message: AuthMessage) => void): () => void {
  const channel = open();
  if (!channel) return () => undefined;
  channel.onmessage = (event: MessageEvent<AuthMessage>) => listener(event.data);
  return () => channel.close();
}
